<template>
  <div>
    <div
      :class="$style.contactEmailVerification"
      v-if="!contactEmailVerified"
    >
      <BaseAlert
        :text="t('email_templates.verification_alert.text')"
        color="warning"
        :primaryAction="t('email_templates.verification_alert.action')"
        @primaryAction="verifyContactEmail"
        v-test="'contact-email-verification-alert'"
      />
    </div>
    <Flex
      direction="column"
      :gap="1"
    >
      <BaseCard>
        <MessageBlock
          :title="$t('marketing.email.new_message.title')"
          :description="$t('marketing.email.new_message.description', brandName())"
          :buttonText="$t('global.actions.create')"
          buttonRoute="newsletter-template"
        />
        <TemplatesOverview />
      </BaseCard>
      <BaseCard>
        <AutomatedEmails v-test="'automated-emails'" />
      </BaseCard>
      <BaseCard>
        <MessageBlock
          :title="$t('marketing.email.messages_log.title')"
          :description="$t('marketing.email.messages_log.description')"
          :buttonText="$t('marketing.email.messages_log.route')"
          buttonRoute="messages"
        />
      </BaseCard>
    </Flex>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import { brandName } from '@/helpers/brand-name';
import { useContactEmailVerification } from '../useContactEmailVerification';
import AutomatedEmails from './AutomatedEmails.vue';
import MessageBlock from './MessageBlock.vue';
import TemplatesOverview from './templates-overview/index.vue';

const { contactEmailVerified, verifyContactEmail } =
  useContactEmailVerification();

const { t } = useI18n();
</script>

<style
  lang="scss"
  module
>
.contactEmailVerification {
  margin-bottom: $spacing * 2;
}
</style>
